import { Layout } from '../../components/Layout';

import { PageContent } from '../../components/PageContent';
import { TitleBlock } from '../../components/PageBlocks/TitleBlock';
import { JobsBlock } from 'components/PageBlocks/JobsBlock';

import styles from './index.module.scss';

import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import CookiesPopup from 'components/CookiesPopup';

const CareerPage = () => {
	const mainData = useSelector((state: RootState) => state.data.data);
	const karier = mainData.karier;

	return (
		<Layout className={styles.page}>
			<PageContent>
				<TitleBlock className={styles.page__title} type='h1'>
					{karier.name}
				</TitleBlock>
				<JobsBlock data={Object.values(karier.images)[0]} />
			</PageContent>
			{!!mainData.config.file_policy_1 && (
				<CookiesPopup link={mainData.config.file_policy_1} />
			)}
		</Layout>
	);
};

export { CareerPage };
